import { createContext } from "react";

const MainContext = createContext({
    showLoginModal: false,
    showLogin: () => {},
    hideLogin: () => {},
    loggedIn: false,
    login: () => {},
    logout: () => {},
    shoppingCart: [],
    addToShoppingCart: () => {},
    removeFromShoppingCart: () => {},
    clearShoppingCart: () => {},
    factureInfo: '',
    setFactureInfo: () => {},
    appSetting: undefined,
    setAppSetting: () => {},
});

export default MainContext;
